module.exports = __webpack_public_path__ + "img/9.c10c6541.jpg";